import React, { Component } from 'react';
import { ISbgListClosedProps, ISbgListClosedState, ISbgListItem } from './SbgListClosed.types';

/**
 * Lists all statsbidrag that are closed.
 * The data is sent to the component in one piece but the user must click on the load more button to see more.
 */
export class SbgListClosed extends React.Component<ISbgListClosedProps, ISbgListClosedState> {
  static defaultProps = {
    closedItems: [] as ISbgListItem[],
    initialShowCount: 10,
    loadCountPerClick: 5,
  };

  constructor(props: ISbgListClosedProps) {
    super(props);

    const { closedItems, initialShowCount } = this.props;

    this.state = {
      renderedItemCount: closedItems.length < initialShowCount ? closedItems.length : initialShowCount,
    };
  }

  onLoadMoreClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();

    const { closedItems, loadCountPerClick } = this.props;
    const { renderedItemCount } = this.state;

    const notRendered = closedItems.length - renderedItemCount;
    const renderCountForNextState = notRendered < loadCountPerClick ? notRendered : loadCountPerClick;

    this.setState({
      renderedItemCount: renderedItemCount + renderCountForNextState,
    });
  };

  private _renderListItem(item: ISbgListItem, index: number) {
    return (
      <div className="datelist-item datelist-item--closed" key={`closed_for_application_${index}`}>
        <div className="datelist-item__datewrap">
          <div className="small-text">Ansök senast</div>
          <div className="datelist-item__date">
            <div>{`${item.LastApplicationDate} `}</div>
            <div>{`${item.LastApplicationDateYear}`}</div>
          </div>
        </div>
        <div className="datelist-item__body">
          <h3>
            <a href={`${item.ItemUri}`}>{`${item.Title}`}</a>
          </h3>
          <div className="small-text">Ansökningstiden har gått ut</div>
        </div>
      </div>
    );
  }

  public render() {
    const { closedItems, hideButton, hideHeading } = this.props;
    const { renderedItemCount } = this.state;
    const toRender = closedItems.slice(0, renderedItemCount);
    const isButtonDisabled = renderedItemCount == closedItems.length;
    const buttonText = isButtonDisabled ? 'Se fler' : `Se fler (${closedItems.length - renderedItemCount} kvar)`;
    return (
      <>
        {!hideHeading && <h2>Stängda för ansökan</h2>}
        <div role="log" aria-atomic="false">
          {toRender.length < 1 ? (
            <p>Det finns inga stängda statsbidrag att visa.</p>
          ) : (
            toRender.map((item, i) => this._renderListItem(item, i))
          )}
        </div>
        {!hideButton && (
          <div className="centered-button">
            <input
              className={`button button--border`}
              disabled={isButtonDisabled}
              type="button"
              value={buttonText}
              onClick={this.onLoadMoreClick}
            />
          </div>
        )}
      </>
    );
  }
}
